import { render, staticRenderFns } from "./PrevBtn.vue?vue&type=template&id=4f2dfe8d"
import script from "./PrevBtn.vue?vue&type=script&lang=js"
export * from "./PrevBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2dfe8d')) {
      api.createRecord('4f2dfe8d', component.options)
    } else {
      api.reload('4f2dfe8d', component.options)
    }
    module.hot.accept("./PrevBtn.vue?vue&type=template&id=4f2dfe8d", function () {
      api.rerender('4f2dfe8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/PrevBtn.vue"
export default component.exports